// extracted by mini-css-extract-plugin
export default {"melodyVideo":"xK-z","isFullWidth":"yK-z","landingPageVideo":"zK-z","play":"AK-z","iframeVideo":"BK-z","playHidden":"CK-z","fullwidth":"DK-z"};